// extracted by mini-css-extract-plugin
export default {"root":"_2dwfH","normal":"_3ezoA","small":"_2HcLZ"};